import * as R from 'ramda'
import { ignoreElements, tap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import {
  getDaysSinceStartSale,
  getFiltersProducts,
  getFrom,
  getIsCatalogOrUniversePagePath,
  getIsProductPagePath,
  getNbFilteredProductsReferences,
  getNormalizedNbSubUniversesInCatalog,
  getNormalizedNbUniversesInCatalog,
  getOperationCode,
  getSaleStartTime,
  getSubUniverseName,
  getUniverseName
} from 'store/selectors'
import {
  getProductPosition,
  getProductCallPrice,
  getProductPrice,
  getProductSourceKey,
  getProductTitle
} from 'domain/products'
import { getResourceByKey } from 'domain/resources'
import { MIXPANEL_ACCESS_MAP } from 'constants/mixpanel'
import { disableMixPanelTracking } from '../disable'
import { getViewedProductsData } from './viewProductPage'

const getMpEventExtraProps = (
  state,
  product
) => (
  R.cond([
    [
      getIsCatalogOrUniversePagePath,
      R.always({
        '# of References': getNbFilteredProductsReferences(state),
        'Page Name': 'Catalogue Page',
        'Product Position': getProductPosition(product)
      })
    ], [
      getIsProductPagePath,
      R.always({
        ...getViewedProductsData(state),
        'Access': MIXPANEL_ACCESS_MAP[getFrom(state)] || '',
        'Page Name': 'Product Page'
      })
    ]
  ])(state)
)

const mapStateToMPEvent = (
  eventName,
  state,
  action // action: OnReadMoreClick
) => {
  const { productKey, productPosition } = action.payload
  const product = getResourceByKey(state, productKey)
  const filteredProducts = getFiltersProducts(state)

  return ({
    ...getMpEventExtraProps(state, { ...product, position: productPosition }),
    '# of Sub Universes': getNormalizedNbSubUniversesInCatalog(state),
    '# of Universes': getNormalizedNbUniversesInCatalog(state),
    'Click Name': 'Click Read More Dropdown',
    'Days Since Sale Start': getDaysSinceStartSale(state),
    'Event Name': eventName,
    'Interaction Type': 'Click',
    'Lowest Price': getProductCallPrice(product),
    'Operation Code': getOperationCode(state),
    'Product': getProductTitle(product),
    'Product ID': getProductSourceKey(product),
    'Product Price': getProductPrice(filteredProducts, product)?.price ?? null,
    'Sale Start Time': getSaleStartTime(state),
    'Stock Status': product.outOfStock ? 'Not Available' : 'Available',
    'Under Universe': getSubUniverseName(state),
    'Universe': getUniverseName(state)
  })
}

const clickProductBulletpointsEpic = (
  actions$,
  state$
) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(Actions.product.READ_MORE_CLICK),
  tap(action => {
    const eventName = 'Click'

    track(eventName, mapStateToMPEvent(eventName, state$.value, action), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default clickProductBulletpointsEpic
